const TabIndicator = () => <span className="MuiTabs-indicatorSpan" />;
export default TabIndicator;
